export const blogData = [
    {
        id: 1,
        title: '“blink-It” Clone',
        description: 'Here I have elaborated the detailing of our project, which consists of the step by step procedure of making “blink-It” Clone.',
        date: 'Apr 5, 2022',
        image: 'https://miro.medium.com/max/875/1*J2lxr_tAx_YxoGNO2CTwhg.gif',
        url: 'https://medium.com/@mdarshadkhan1998/blink-it-clone-1ee07cd65ace'
    },
    {
        id: 2,
        title: 'Clone of bobbibrowncosmetics.com',
        description: 'This blog consists of details of all the functionalities which we have implemented while cloning bobbibrowncosmetics.com .',
        date: 'May 22, 2022',
        image: 'https://miro.medium.com/max/875/0*wfdjI-sowxqoGakq.gif',
        url: 'https://medium.com/@mdarshadkhan1998/clone-of-bobbibrowncosmetics-com-5e0baa7bd62b'
    }
]